import InstallationCupsPage from './InstallationCupsPage';

export default InstallationCupsPage;
